<template>
  <section id="portfolio" class="section bg-light">
    <div class="container">
      <!-- Heading -->
      <p class="text-center mb-2" data-aos="fade-up" data-aos-once="true">
        <span class="bg-primary text-dark px-2">Portfolio</span>
      </p>
      <h2 class="text-10 fw-600 text-center mb-5" data-aos="fade-up" data-aos-once="true">
        Some of my most recent projects
      </h2>
      <!-- Heading end-->

      <div class="portfolio" data-aos="fade-up" data-aos-once="true">
        <div class="row g-4 mt-3 portfolio-filter">
          <template v-for="(appdata) in fillter_data" :key="appdata.id">
            <div v-for=" (subdata, index) in appdata" :key="subdata" class="col-sm-6 col-lg-4 filter'"
              @click="project_data(index)" data-bs-toggle="modal" data-bs-target="#exampleModal">
              <div class="portfolio-box">
                <div class="portfolio-img">
                  <img class="img-fluid d-block" :src="require(`@/${subdata.projecr_image[0]}`)" alt="" />
                  <div class="portfolio-overlay">

                    <div class="portfolio-overlay-details">
                      <p class="text-primary text-8">
                        <i class="fas fa-file-alt"></i>
                      </p>
                      <h5 class="text-white text-5">{{ subdata.project_title }}</h5>
                      <span class="text-light">{{ subdata.term_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>

<!--   <ModelPopup :title="title" :project_img="project_img" :pdescription="project_desc" :prdate="pdate"
    :ptech="ptechnologies" :purl="psite" /> -->
</template>

<script>
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import jQuery from "jquery";
import logosobj from "@/json/logo.json";
import appsobj from "@/json/app.json";
import websitesobj from "@/json/website.json";
import dashboardobj from "@/json/dashboard.json";
import wireframingobj from "@/json/wireframing.json";
import appscreenshotobj from "@/json/appscreenshot.json";
import logosdata from "@/json/bhavindata.json";
/* import ModelPopup from "@/components/ModelPopup.vue"; */

export default {
  name: "MyPortfolio",
/*   components: {
    ModelPopup
  }, */
  data() {
    return {
      logos:logosobj,
      apps:appsobj,
      websites:websitesobj,
      dashboars:dashboardobj,      
      wireframing:wireframingobj,
      appscreenshot:appscreenshotobj,  
      app_image: logosdata,
      title: '',
      project_img: "",
      project_desc: '',
      pdate: '',
      ptechnologies: '',
      psite: '',
      fillter_data: ''
    }
  },
  methods: {
    filterbutton(e) {
      let allfilter = e.target.attributes["data-filter"].value;
      if (allfilter == "all") {
        jQuery(".filter").show("1000");
      } else {
        jQuery(".filter")
          .not("." + allfilter)
          .hide("3000");
        jQuery(".filter")
          .filter("." + allfilter)
          .show("3000");
      }

      jQuery(document).on("click", ".portfolio-menu a", function () {
        jQuery(".portfolio-menu").find("a").removeClass("active");
        jQuery(this).addClass("active");
      });
    },
    project_data(dataid) {
      let navitem = this[dataid][0]
      this.title = navitem.project_title;
      this.project_img = navitem.projecr_image;
      this.project_desc = navitem.project_desc;
      this.pdate = navitem.project_date;
      this.ptechnologies = navitem.project_technologies;
      this.psite = navitem.project_url;

      const fancyImages = Object.values(navitem.projecr_image).map(img => ({
          src: require(`@/${img}`),
          thumb: require(`@/${img}`)
      }));

      Fancybox.bind('[data-fancybox="gallery"]')
      Fancybox.show(fancyImages, { startIndex: 0 });
    }
  },
  mounted() {
    const array = [];
    array.push({ "logos": this.logos[0] }, { "apps": this.apps[0] },{ "websites": this.websites[0]},{ "dashboars": this.dashboars[0]},{"wireframing": this.wireframing[0]},{"appscreenshot": this.appscreenshot[0]});
    this.fillter_data = array; 

  }
};
</script>

<style scoped>

</style>